@if (viewModel | async; as data) {
  <div class="checkbox-tree">
    @if ((enableSelectAll && !data.hasFilter) || (enableSelectFiltered && data.hasFilter)) {
      <div class="checkbox-tree__header">
        <div class="checkbox-tree__header-vertical-align">
          @if (enableSelectAll && !data.hasFilter) {
            <ftr-basic-checkbox
              class="checkbox-tree__header-checkbox"
              [value]="getSelectAllValue(data.filteredItems)"
              (valueChange)="selectAll(data.filteredItems, $event)"
              [name]="'Select All'"
              tabindex="0"
            >
            </ftr-basic-checkbox>
          }
          @if (enableSelectFiltered && data.hasFilter) {
            <div>
              <ftr-basic-checkbox
                class="checkbox-tree__header-checkbox"
                [value]="getSelectFilteredValue(data.filteredItems)"
                (valueChange)="selectAllFiltered(data.filteredItems, $event)"
                [name]="'Select All Filtered ' + pluralNoun + ' (' + data.totalFilterCount + ')'"
                tabindex="0"
              >
              </ftr-basic-checkbox>
            </div>
          }
        </div>
      </div>
    }
    @for (item of data.filteredItems; track trackById($index, item)) {
      <div>
        <ftr-composable-collapse
          class="checkbox-tree"
          [hidden]="item.hidden"
          [isOpen]="!item.collapsed"
          [headerTemplate]="header"
          [bodyTemplate]="body"
          (keydown.space)="item.collapsed = !item.collapsed"
          (keydown.enter)="setParentSelected(item, item.value !== true)"
        >
          <ng-template #header>
            <div class="checkbox-tree__header">
              <div class="checkbox-tree__header-vertical-align">
                <ftr-basic-checkbox
                  class="checkbox-tree__header-checkbox"
                  [name]="item.title"
                  (keydown.space)="item.collapsed = !item.collapsed"
                  (keydown.enter)="setParentSelected(item, item.value !== true)"
                  icon="AccountBalance"
                  [value]="item.value"
                  (valueChange)="setParentSelected(item, $event)"
                  [disabled]="item.disabled"
                >
                </ftr-basic-checkbox>
              </div>
            </div>
          </ng-template>
          <ng-template #body>
            <ul class="checkbox-tree__body">
              @if (enableSelectFiltered && data.hasFilter && item.getShowChildrenCount() > 1) {
                <li class="checkbox-tree__body-item">
                  <ftr-basic-checkbox
                    class="checkbox-tree__select-all-checkbox"
                    [value]="item.filterValue"
                    (valueChange)="setFilteredParentSelected(item, $event)"
                    [name]="'Select Filtered ' + pluralNoun + ' (' + item.getShowChildrenCount() + ')'"
                  >
                  </ftr-basic-checkbox>
                </li>
              }
              @for (child of item.items; track trackById($index, child)) {
                <li class="checkbox-tree__body-item" [hidden]="child.hidden">
                  <ftr-basic-checkbox
                    class="checkbox-tree__body-checkbox"
                    [hidden]="child.hidden"
                    [name]="child.title"
                    [value]="child.selected"
                    [disabled]="child.disabled"
                    (valueChange)="onSelectionChange($event, child.id)"
                    (keydown.enter)="onSelectionChange(!child.selected, child.id)"
                  >
                  </ftr-basic-checkbox>
                </li>
              }
            </ul>
          </ng-template>
        </ftr-composable-collapse>
      </div>
    }
  </div>
}
